import React from 'react';
import { Routes, useLocation, Route } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Home from '../pages/Home';
import About from '../pages/About';
import Services from '../pages/Services';
import Policies from '../pages/Policies';
import Contact from '../pages/Contact';

// 🔸 Varianti transizione globale
const pageTransition = {
  hidden: { opacity: 0, y: 20, scale: 0.98 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.7, ease: [0.25, 0.1, 0.25, 1] },
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: { duration: 0.5, ease: 'easeInOut' },
  },
};

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <motion.div variants={pageTransition} initial="hidden" animate="visible" exit="exit">
              <Home />
            </motion.div>
          }
        />
        <Route
          path="/chi-siamo"
          element={
            <motion.div variants={pageTransition} initial="hidden" animate="visible" exit="exit">
              <About />
            </motion.div>
          }
        />
        <Route
          path="/il-nostro-metodo"
          element={
            <motion.div variants={pageTransition} initial="hidden" animate="visible" exit="exit">
              <Services />
            </motion.div>
          }
        />
        <Route
          path="/polizze-assicurative"
          element={
            <motion.div variants={pageTransition} initial="hidden" animate="visible" exit="exit">
              <Policies />
            </motion.div>
          }
        />
        <Route
          path="/contatti"
          element={
            <motion.div variants={pageTransition} initial="hidden" animate="visible" exit="exit">
              <Contact />
            </motion.div>
          }
        />
      </Routes>
    </AnimatePresence>
  );
}

export default AnimatedRoutes;
